import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grey[500],
    cursor: 'pointer',
    marginRight: theme.spacing(2),
    padding: `${theme.spacing(0.25)}px 0`,
    display: 'inline-block'
  },
  styleLabel: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 0
  },
  activeButton: {
    color: theme.palette.grey[400]
  }
}));

export const StyleButton = ({ onToggle, style, active, label }) => {
  const classes = useStyles();
  const handleToggle = (e) => {
    e.preventDefault();
    onToggle(style);
  };

  const className = classnames(
    classes.root,
    active && classes.activeButton
  );

  return (
    <span className={className} onMouseDown={handleToggle}>
      <span className={classes.styleLabel}>
        {label}
      </span>
    </span>
  );
};

StyleButton.propTypes = {
  onToggle: PropTypes.func.isRequired,
  style: PropTypes.string,
  active: PropTypes.bool,
  label: PropTypes.node
};

export default StyleButton;
